/*
 * @Author: beenlezhang
 * @Date: 2022-01-06 15:31:10
 * @LastEditors: yanhongchen
 * @LastEditTime: 2022-08-30 17:44:46
 * @Descripttion: 数据上报
 */
import store from '@/store';
import { locationHref } from '@/config/constant';

const { beaconSDKappKey } = window.AppConfig;

const beaconSDK = !beaconSDKappKey
  ? null
  : new (window as any).BeaconAction({
      appkey: beaconSDKappKey,
      reportUrl: 'https://otheve.beacon.qq.com/analytics/upload?tp=js',
    });

/**
 * 判断当前设备类型 用于埋点上报
 * @returns 判断当前设备类型 用于埋点上报
 *  pc  默认设备
 *  iframe iframe嵌入
 *  applet 小程序
 *  h5 移动设备、微信内置浏览器
 */

export function checkDeviceType() {
  let deviceType = 'pc';
  const userAgent = navigator.userAgent.toLowerCase();
  if (parent !== window) {
    deviceType = 'iframe';
  } else if (/micromessenger/i.test(userAgent)) {
    if (/miniprogram/i.test(userAgent)) {
      deviceType = 'applet';
    } else {
      deviceType = 'h5';
    }
  } else if (/mobile|android|iphone|ipad|phone/i.test(userAgent)) {
    deviceType = 'h5';
  } else {
    deviceType = 'pc';
  }
  return deviceType;
}

/**
 * 默认上报公共参数
 * @return {Object}
 */
const defaultParams = () => {
  // 获取当前设备类型
  const deviceType = checkDeviceType();
  return {
    user_id: store.state.user.userDetail.id,
    url: locationHref,
    // PC端：pc、移动端：h5、小程序：applet、嵌入：iframe
    device_type: deviceType,
  };
};

/**
 * sdkReport 埋点上报
 * @param event
 * @param params 事件参数KEY
 */
const sdkReport = (event = '', params = {}) => {
  if (beaconSDK) {
    beaconSDK.onUserAction(event, {
      ...defaultParams(),
      ...params,
    });
  }
};

export default {
  sdkReport,
};
